const TechnicalApi = [
  {
    id: 1,
    company: "Orane Consulting Pvt. Ltd.",
    designation: "React Intern",
    description: (
      <ul>
        <li>Migration of My Joining to React. (LIVE Project)</li>
        <li>
          Built multiple function-based components with Restful web services
          like PUT, GET and POST methods.
        </li>
        <li> Test and integrate backend API.</li>
        <li> Converted CSS to SCSS and built pages Responsive.</li>
        <li> Worked on Theme changing features.</li>
        <li> Resolved Bugs on the front-end.</li>
      </ul>
    ),
    certificate:
      "https://drive.google.com/file/d/1hJAZG7ajNHL6_QeJj1ugQZIEaxsQjDLT/view?usp=sharing",
  },
];

export default TechnicalApi;
